import styled from 'styled-components'
import { PaginationItemProps, IconWrapperProps } from './types'

export const PaginationContainer = styled('div')`
  display: flex;
  align-items: center;
`

export const IconWrapper = styled('div')<IconWrapperProps>`
  margin: -7px;
  padding-top: 4px;
  opacity: ${props => (props.disabled ? '0.3' : '1')};
`

export const PaginationItem = styled('button')<PaginationItemProps>`
  min-width: 32px;
  height: 32px;
  background-color: ${props =>
    props.theme.colors.main[props.selected ? 'ultraViolet' : 'background']};
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  padding: 8px;
  margin: 0 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    cursor: default;
  }
`

export const DotsWrapper = styled('div')`
  margin: 0 4px;
  padding: 8px;
  background-color: ${props => props.theme.colors.main.background};
  cursor: default;
  user-select: none;
`
